import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { TaskService, SERVICE_CONFIG } from '../../services/task.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'nf-check-list',
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.css']
})
export class CheckListComponent implements OnInit, AfterViewInit {
  // filterList = [
  //   {
  //     status: 'all',
  //     title: '查看全部'
  //   },
  //   {
  //     status: 'only_diff',
  //     title: '仅查看差异'
  //   },
  // ];
  // condition = {
  //   status: 'all',
  //   title: '查看全部'
  // };
  // filterVisible = false;
  color = {
    'equal': '',
    'unequal': '#ee7d69',
    'extra': '#c89e2d',
    'absent': '#ef6ade',
  };
  dataSource1: any = [];
  dataSource2: any = [];
  columsList: any = { // 表头字段
    "dataSources": [
      {
        "id":"",
        "name":""
      },
      {
        "id":"",
        "name":""
      }
    ],
    "columns": {
      "dataSourceId1": [],
      "dataSourceId2": []
    },
  };

  dataList = [];

  tableWidth1 = 0;
  tableWidth2 = 0;
  tableWidth3 = 0;
  show = false; // 数据对比详情

  dataDetailHead = []; // 详情表头
  dataDetail = [];
  dataDetail1: any = {}; // 数据源1详情数据
  dataDetail2: any = {}; // 数据源2详情数据
  executionId: any;

  page = {
    page: 1,
    rows: 20,
    total: 0
  };
  countHeight = 400;
  layerHeight = 610;
  pageLoading = false;

  dataSource1Footer: any = [];
  dataSource2Footer: any = [];
  title = {
    source1: 0,
    source2: 0
  };
  formTemplate = {
    "form": {
      "autoComplete": "off",
      "groupStyle": "default",
      "labelNewLine": false,
      "formCollapsed": 2
    },
    "properties": [
      // {
      //   "type": "input",
      //   "label": "姓名",
      //   "name": "name",
      //   "items": 3,
      //   "labelCol": 6,
      //   "controlCol": 18
      // },
      // {
      //   "type": "textRange",
      //   "label": "区间字段",
      //   "name": "phone",
      //   "items": 3,
      //   "labelCol": 6,
      //   "controlCol": 18
      // },
      // {
      //   "type": "select",
      //   "label": "邮箱",
      //   "name": "email",
      //   "items": 3,
      //   "labelCol": 6,
      //   "controlCol": 18,
      //   "serverConfig": {
      //     "option": {
      //       "1": '选项1',
      //       "2": '选项2',
      //       "3": '选项3',
      //       "4": '选项4',
      //     },
      //   }
      // }
    ]
  };
  isQueryLoading = false;
  params = {};
  environment = {};
  formCollapsed = 2;           // 查询区域默认显示2行
  isQueryCollapsed = true;    // 查询区域是否展开

  @ViewChild('queryForm') queryForm: any;
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
  ) { }

  ngOnInit() {
    this.environment = SERVICE_CONFIG.environment;
    this.countHeight = document.body.clientHeight - 350;
    this.layerHeight = this.countHeight + 210;
  }

  ngAfterViewInit() {
  }

  // 查询区域展开收缩
  queryCollapse() {
    this.isQueryCollapsed = !this.isQueryCollapsed;
  }

  listenerScroll() {
    setTimeout(() => {
      document.querySelector('.table-left .ant-table-body').addEventListener('scroll', (e: any) => {
        document.querySelector('.table-right .ant-table-body').scrollLeft = e.target.scrollLeft;
        document.querySelector('.table-right .ant-table-body').scrollTop = e.target.scrollTop;
        if (document.querySelector('.table-left .source1-footer .ant-table-body')) {
          document.querySelector('.table-left .source1-footer .ant-table-body').scrollLeft = e.target.scrollLeft;
          document.querySelector('.table-left .source1-footer .ant-table-body').scrollTop = e.target.scrollTop;
        }
      });
      document.querySelector('.table-right .ant-table-body').addEventListener('scroll', (e: any) => {
        document.querySelector('.table-left .ant-table-body').scrollLeft = e.target.scrollLeft;
        document.querySelector('.table-left .ant-table-body').scrollTop = e.target.scrollTop;
        if (document.querySelector('.table-right .source2-footer .ant-table-body')) {
          document.querySelector('.table-right .source2-footer .ant-table-body').scrollLeft = e.target.scrollLeft;
          document.querySelector('.table-right .source2-footer .ant-table-body').scrollTop = e.target.scrollTop;
        }
      });
    }, 1000);
  }

  // 展示数据对比详情
  openDetail(index, type) {
    this.dataDetail = [];
    this.dataDetail1 = {};
    this.dataDetail2 = {};
    this.dataDetail1['source'] = this.columsList.dataSources[0].name;
    this.dataDetail1['order'] = index + 1;
    this.dataDetail2['source'] = this.columsList.dataSources[1].name;
    this.dataDetail2['order'] = index + 1;

    this.dataDetailHead = [];
    this.columsList.columns.dataSourceId1.forEach( (item1, i) => {
      this.dataDetail1[item1.code] = this.dataSource1[index][item1.code];
      if (this.dataSource1[index][item1.code + 'Unequal']) {
        this.dataDetail1[item1.code + 'Unequal'] = this.dataSource1[index][item1.code + 'Unequal'];
      }

      // 根据返回的表头字段顺序去获取数据源2对应的字段名
      const code2 = this.columsList.columns.dataSourceId2[i].code; // 获取数据源2的对应code值
      this.dataDetail2[code2] = this.dataSource2[index][code2];
      if (this.dataSource2[index][code2 + 'Unequal']) {
        this.dataDetail2[code2 + 'Unequal'] = this.dataSource2[index][code2 + 'Unequal'];
      }

      const head = {
        name: item1.name === this.columsList.columns.dataSourceId2[i].name ? item1.name : item1.name + '/' + this.columsList.columns.dataSourceId2[i].name
      };
      this.dataDetailHead.push(head);
    });
    this.dataDetail1['status'] = this.dataSource1[index]['status'];
    this.dataDetail2['status'] = this.dataSource2[index]['status'];
    this.dataDetail.push(this.dataDetail1);
    this.dataDetail.push(this.dataDetail2);
    this.show = true;
  }

  // 收起数据对比详情
  hiddenDetail() {
    this.show = false;
  }

  // 页码改变
  changePage(e) {
    this.page.page = e;
    this.getDataList();
  }

  // 页码条数改变
  changeSize(e) {
    this.page.rows = e;
    this.page.page = 1;
    this.getDataList();
  }

  // 获取表头数据
  getColumsList() {
    this.page.page = 1;
    this.taskService.getHeadList(this.executionId).subscribe(res => {
      const template = JSON.parse(JSON.stringify(this.formTemplate));
      template.properties = res['searchCondition'] ? res['searchCondition'] : [];
      this.formTemplate = template
      this.columsList.dataSources = res['data'].dataSources;
      const source1Id = this.columsList.dataSources[0].id;
      this.columsList.columns.dataSourceId1 = res['data'].columns[0][source1Id];
      const source2Id = this.columsList.dataSources[1].id;
      this.columsList.columns.dataSourceId2 = res['data'].columns[1][source2Id];
      this.tableWidth2 = this.columsList.columns.dataSourceId1.length * 200;
      this.tableWidth1 = this.tableWidth2 + 20;
      this.tableWidth3 = this.tableWidth1 + 150;
      this.getDataList();
    });
  }

  // 获取总记录数
  getTotal() {
    const params = JSON.parse(JSON.stringify(this.params));
    for (const key in params) {
      if (typeof params[key] === 'object') {
        delete params[key];
      }
    }
    this.taskService.getTotalData(this.executionId, params).subscribe( res => {
      this.getStatistic(res ? res : {});
    });
  }

  getStatistic(data) {
    if (data.statistics) {
      const statistics = JSON.parse(data.statistics);
      const source1Id = this.columsList.dataSources[0].id;
      const source2Id = this.columsList.dataSources[1].id;
      this.title = {
        source1: statistics[0][source1Id] && statistics[0][source1Id].total ? statistics[0][source1Id].total : 0,
        source2: statistics[1][source2Id] && statistics[1][source2Id].total ? statistics[1][source2Id].total : 0
      };
      this.dataSource1Footer = [];
      this.dataSource2Footer = [];
      if (statistics[0][source1Id] && statistics[0][source1Id].statistic && statistics[0][source1Id].statistic.length) {
        const obj1 = {};
        statistics[0][source1Id].statistic.forEach( item => {
          obj1[item.code] = item.value;
        });
        this.dataSource1Footer.push(obj1);
      }
      if ( statistics[1][source2Id] && statistics[1][source2Id].statistic && statistics[1][source2Id].statistic.length) {
        const obj2 = {};
        statistics[1][source2Id].statistic.forEach( item => {
          obj2[item.code] = item.value;
        });
        this.dataSource2Footer.push(obj2);
      }
    } else {
      this.title = {
        source1: null,
        source2: null
      };
      this.dataSource1Footer = [];
      this.dataSource2Footer = [];
    }
  }

  // 获取列表数据
  getDataList() {
    this.pageLoading = true;
    const params = JSON.parse(JSON.stringify(this.params));
    for (const key in params) {
      if (typeof params[key] === 'object') {
        delete params[key];
      }
    }
    const param = {
      page: this.page.page,
      rows: this.page.rows,
      ...params
    };
    this.taskService.getExecutionsList(this.executionId, param).subscribe(res => {
      this.pageLoading = false;
      this.isQueryLoading = false;
      this.dataSource1 = [];
      this.dataSource2 = [];
      const data = res['_embedded'] ? res['_embedded']['vos'] : [];
      data.forEach(item => {
        const obj1 = {};
        const obj2 = {};
        const source1Id = this.columsList.dataSources[0].id;
        this.columsList.columns.dataSourceId1.forEach(source1 => {
          obj1[source1.code] = item['columnValues'][0][source1Id][source1.code].value;
          if (item.status === 'unequal' && item['columnValues'][0][source1Id][source1.code].status === 'unequal') {
            obj1[source1.code + 'Unequal'] = true; // 单个字段标红标识
          }
        });
        obj1['status'] = item['status'];
        this.dataSource1.push(obj1);

        const source2Id = this.columsList.dataSources[1].id;
        this.columsList.columns.dataSourceId2.forEach( source2 => {
          obj2[source2.code] = item['columnValues'][1][source2Id][source2.code].value;
          if (item.status === 'unequal' && item['columnValues'][1][source2Id][source2.code].status === 'unequal') {
            obj2[source2.code + 'Unequal'] = true; // 单个字段标红标识
          }
        });
        obj2['status'] = item['status'];
        this.dataSource2.push(obj2);
      });
      this.page.total = res ? res['page'].totalElements : 0;
    }, ( () => {
      this.pageLoading = false;
      this.isQueryLoading = false;
    }));
  }

  // 显示过滤条件
  // showFilter() {
  //   this.filterVisible = true;
  // }

  // 更改过滤条件
  // changeFilter(item) {
  //   this.condition = item;
  //   this.filterVisible = false;
  //   this.getDataList();
  //   this.show = false;
  // }

  // setCondition() {
  //   this.condition = {
  //     status: 'all',
  //     title: '查看全部'
  //   };
  // }

  // excel导出
  exportHandle() {
    const param = JSON.parse(JSON.stringify(this.params));
    for (const key in param) {
      if (typeof param[key] === 'object') {
        delete param[key];
      }
    }
    this.taskService.exportExcel(param, this.executionId);
  }

  // 清空
  emptyForm() {
    this.queryForm.resetForm();
  }

  // 搜索
  searchHandle(event) {
    this.isQueryLoading = true;
    this.queryForm.handleSubmit(event);
  }

  // 查询条件回车
  enterQuery(event) {
    this.isQueryLoading = true;
    // 长时间没得到父组件传入数据，自动停止
    this.queryForm.handleSubmit(event);
  }

  doSubmit(event) {
    this.params = event;
    this.getDataList();
    this.getTotal();
  }
}
